import { render } from "./RestoreWallet.vue?vue&type=template&id=09817027"
import script from "./RestoreWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./RestoreWallet.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/RestoreWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09817027"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09817027', __exports__)) {
    api.reload('09817027', __exports__)
  }
  
  module.hot.accept("./RestoreWallet.vue?vue&type=template&id=09817027", () => {
    api.rerender('09817027', render)
  })

}


export default __exports__